import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import {
  convertArrayWithSeperator,
  generateNewChatId } from
"../../../utils/TutorConstants";
import {
  getTimeDifference,
  getUpdateJourneyDetails,
  isEmptyOrNull,
  isNotEmptyOrNull,
  urlString,
  handleVideoEvent } from
"../../../utils/common-utils";
import {
  questionTypes,
  taskTypes,
  status } from
"../../../utils/LearningPathUtils";

import DescriptiveAnswer from "./DescriptiveAnswer";
import FeedbackModal from "../../../components/organisms/ai-tutor/FeedbackModal";
import { Box, Center, HStack, Image, Text, useToast } from "@chakra-ui/react";
import LearnSideNav from "../../../components/molecules/learnSideNav/learnSideNav";
// import MediaModal from "../../../components/molecules/ai-tutor/MediaModal/MediaModal";
import pkg from "@inrscr/coschool-ui-components";
import Modal from "../../../components/molecules/modal/Success";
import PlainInput from "../Editor/PlainInput";
import PracticeByQuestion from "./PracticeByQuestion";
import PracticeHistoryBottomSheet from "./PracticeHistoryBottomSheet";
import PracticeHistoryList from "./PracticeHistoryList";
import PracticeLayout from "./PracticeLayout";
import PracticeMedia from "./PracticeMedia";
import RightArrowicon from "../../../assets/svgs/RightArrowicon.svg";
import TutorReviewMode from "../../review/TutorReviewMode";
import WelcomeClassifier from "../Classifier/WelcomeClassifier";
import { matchFibAnswers } from "../../../utils/Helper";
import styles from "./practice.module.css";
import { updateJourney } from "../../../api/task-services";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "@remix-run/react";
import { usePractice } from "../../../context/PracticeContext";
import { useRoot } from "../../../context/RootContext";
import useStateRef from "react-usestateref";
import { useTutor } from "../../../context/AiTutorContext";
import { postFactualProgress } from "../../../network/LearnApiService";
import { StorageService } from "../../../utils/StorageUtils";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import RelatedContent from "../../../assets/ai-tutor/related-content.svg";
import { useCustomNavigation } from "../../../hooks/useCustomNavigation";
import { ROUTES } from "../../../utils/navigationUtils";
import { getAuthToken } from "../../../api/login-service";

const Practice = (props) => {
  const { MediaModal } = pkg;
  const isMobile = useMediaQuery({
    query: "(max-width: 768px)"
  });
  const toast = useToast();
  const location = useLocation();
  const divRef = useRef(null);
  const isUserScrolled = useRef(false);
  const {
    handleFetchQuestions,
    handlePracticeConv,
    setChatId,
    buttons,
    chatHistory,
    streamingText,
    currentQuesIndex,
    chatId,
    handleNextQuestion,
    setIsConvCompleted,
    isLastQues,
    selectedJourney,
    setSelectedJourney,
    displayedQues,
    setDisplayedQues,
    setCurrentQuestionIndex,
    resetPractice,
    mediaDetails,
    learningStepData,
    setShowNextBtnForFactual,
    isAnswerSubmitted,
    setIsAnswerSubmitted,
    isDescAnsQues,
    setDisplayQuestionsWithoutFactualVideo,
    handleLongAnsStreamFlow,
    taskCategory,
    setTaskCategory,
    setQuestionStartTime,
    setQuestionEndTime,
    questionStartTime,
    isDescSubmitted,
    setIsNextQuestionLoading,
    isNextQuestionLoading
  } = usePractice();
  const {
    classifierInfo,
    setUserQuery,
    openFeedbackModal,
    setOpenFeedbackModal,
    isTaskCompleted,
    setIsTaskCompleted,
    setIsFeedbackSubmitted,
    curriculumObj,
    setOverAllQuestionResult,
    overAllQuestionResult,
    setAnswerCount,
    setSelectedSubTopic,
    setSelectedTopic,
    selectedSubTopic,
    setSubject,
    setTopic,
    setTopicMasterUuid,
    setSubjectMasterUUid,
    selectedTopic,
    experientialLearningData,
    isPlayerOpen,
    setIsPlayerOpen,
    selectedFactualIndex,
    journeyId,
    setSubTopic,
    setSubtopicId,
    setSubtopicMasterUuid
  } = useTutor();

  const {
    openLearnSideMenu,
    openPracSideMenu,
    togglePracDrawer,
    isStandalone,
    setTopicName,
    toggleLearnDrawer,
    setSubTopicName,
    setTaskCatagory,
    taskType,
    setTaskType,
    isPlayground,
    isDiscussFlow,
    setSelectedIndex,
    executionHistoryLoaded,
    setExecutionHistoryLoaded,
    openProfileMenu
  } = useRoot();
  const { classifierStatus } = classifierInfo;
  const [factualIndex, setFactualIndex, factualIndexRef] = useStateRef(0);
  const [isFetching, setIsFetching, isFetchingRef] = useStateRef(false);
  const [allAnswersData, setAllAnswersData] = useState([]);
  const [selectedAnswer, setSelectedAnswer] = useState("");
  const [selectedHashedIndexAnswer, setSelectedHashedIndexAnswer] =
  useState("");
  const [selectedAnswerIndex, setSelectedAnswerIndex] = useState();
  const [selectedMedia, setSelectedMedia] = useState({});
  const [openMedia, setOpenMedia] = useState(false);
  const [factualAnswersList, setFactualAnswersList, factualAnswersListRef] =
  useStateRef([]);
  const [openRelatedContent, setOpenRelatedContent] = useState(false);
  const [backUpObject, setBackUpObject, backUpObjectRef] = useStateRef(null);
  const [authToken, setAuthToken] = useState(null);
  const navigate = useNavigate();
  // const [
  //   practiceSubjectMasterUuid,
  //   setPracticeSubjectMasterUuid,
  //   practiceSubjectMasterUuidRef,
  // ] = useStateRef("");
  // const [
  //   practiceTopicMasterUuid,
  //   setPracticeTopicMasterUuid,
  //   practiceTopicMasterUuidRef,
  // ] = useStateRef("");

  // console.log("PROPS", props);

  // Move useCustomNavigation hook to component body
  const initializeAuthToken = async () => {
    try {
      const token = await getAuthToken();
      setAuthToken(token);
    } catch (error) {
      console.error("Error getting auth token:", error);
      setAuthToken(null);
    }
  };

  // Fix: Initialize auth token when component mounts
  useEffect(() => {
    initializeAuthToken();
  }, []);

  useCustomNavigation(ROUTES?.PRACTICE, isTaskCompleted);

  useEffect(() => {
    const storedBackUp = StorageService.getItem("backUpObject");
    if (isNotEmptyOrNull(storedBackUp)) {
      setBackUpObject(storedBackUp);
    }
    openLearnSideMenu && toggleLearnDrawer();
  }, []);

  useLayoutEffect(() => {
    setSelectedTopic(props?.selectedTopic || "");
    setSelectedSubTopic(props?.selectedSubTopic || "");
    setSubTopicName(
      props?.selectedSubTopic?.taskAttributes?.subtopicName ||
      props?.selectedSubTopic?.subtopicInfo?.name ||
      ""
    );
    setTopicName(
      props?.selectedSubTopic?.taskAttributes?.topicName ||
      props?.selectedTopic?.topic?.topicInfo?.name ||
      ""
    );
    setSubject(
      props?.selectedSubTopic?.taskAttributes?.subjectName ||
      props?.selectedTopic?.topic?.topicInfo?.subject_name ||
      ""
    );
    setTaskCatagory(
      props?.selectedSubTopic?.taskType || props?.actualTaskType || ""
    );
    setSubjectMasterUUid(
      props?.selectedSubTopic?.subjectId ||
      props?.selectedTopic?.subject?.subjectMasterUuid ||
      ""
    );
    setTopicMasterUuid(
      props?.selectedSubTopic?.taskAttributes?.topicMasterUuid ||
      props?.selectedTopic?.topic?.topicMasterUuid ||
      ""
    );
  }, []);

  useEffect(() => {
    handleUpdateTaskType();
  }, [backUpObjectRef.current]);

  const handleVideoEventWithContext = (eventType, eventData = {}) => {
    const eventObj = {
      event_type: eventType,
      ...eventData
    };

    handleVideoEvent(eventObj, learningStepData, taskType, selectedTopic);
  };

  const handleUpdateTaskType = () => {
    let taskTypeName = "";
    let pathName = location?.pathname;
    if (
    isNotEmptyOrNull(props?.selectedSubTopic?.taskType) ||
    isNotEmptyOrNull(props?.actualTaskType))
    {
      taskTypeName = props?.selectedSubTopic?.taskType || props?.actualTaskType;
    } else if (isNotEmptyOrNull(backUpObjectRef?.current)) {
      taskTypeName = backUpObjectRef?.current?.taskType;
    } else if (
    pathName?.includes("practice") ||
    pathName?.includes("/playground"))
    {
      taskTypeName = taskTypes.guidedPractice;
    } else {
      taskTypeName = taskTypes.assessment;
    }
    setTaskType(taskTypeName);
  };
  useEffect(() => {
    let callAPI =
    classifierStatus === 2 &&
    !isEmptyOrNull(taskCategory) &&
    isFetchingRef?.current === false &&
    isStandalone &&
    !props?.passByQuestion;
    if (callAPI) {
      setIsFetching(true);
      handleFetchQuestions();
    }
  }, [taskCategory, classifierStatus]);
  const [showSubmit, setShowSubmit, showSubmitRef] = useStateRef(false);

  useEffect(() => {
    const container = divRef.current;
    const handleScroll = () => {
      const isAtBottom =
      container.scrollHeight - container.clientHeight <=
      container.scrollTop + 5;
      if (!isAtBottom) {
        isUserScrolled.current = true;
      } else {
        isUserScrolled.current = false;
      }
    };
    container.addEventListener("scroll", handleScroll);
    requestAnimationFrame(() => {
      container.scrollTop = container.scrollHeight;
    });
    return () => container.removeEventListener("scroll", handleScroll);
  }, [chatHistory, streamingText, executionHistoryLoaded]);

  useEffect(() => {
    if (isNotEmptyOrNull(experientialLearningData)) {
      navigate(`${urlString}/experiential`, {
        state: {
          experientialLearningData: experientialLearningData
        }
      });
    }
  }, [experientialLearningData]);

  useEffect(() => {
    const timer = setTimeout(() => {
      const container = divRef.current;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [displayedQues]);

  const closeLearnSideNav = () => {
    toggleLearnDrawer();
  };

  const toggleRelatedContent = () => {
    setOpenRelatedContent((prev) => !prev);
  };

  const handleNavItemCLick = (data) => {
    toggleLearnDrawer();
    let journeyId = data?.journeyId;
    if (isNotEmptyOrNull(journeyId)) {
      setSelectedJourney(journeyId);
    }
  };

  const handleSubmitDescriptiveAnswer = async (data, images) => {
    // let uuid = generateNewChatId();
    // setChatId(uuid);
    setIsAnswerSubmitted(true);
    setUserQuery(data);
    const curQues = displayedQues[currentQuesIndex];
    let endTime = new Date();
    let obj = {
      answerResult: [
      {
        actualAnswer: curQues?.answers_layout?.[0],
        givenAnswer: data,
        isCorrect: false,
        time_taken: await getTimeDifference(questionStartTime, endTime)
      }],

      overAllResult: false,
      chatId: chatId
    };
    handleButtonClick(obj, 0);
    handleLongAnsStreamFlow(data, images);

    if (!location?.pathname?.includes("practice-by-questionid")) {
      let { basketId, journey } = getUpdateJourneyDetails(
        learningStepData,
        journeyId
      );

      updateJourneyCall(journey, curQues?.version_uuid, basketId, obj);
    }
  };

  //update journey API call
  const updateJourneyCall = async (
  journey_id,
  question_id,
  basket_id,
  totalResultObj) =>
  {
    const response = await updateJourney({
      journeyId: journey_id,
      questionId: question_id,
      basketId: basket_id,
      user_answer: JSON.stringify(totalResultObj)
    });

    // console.log("RESPONSE", response);
  };

  const handleAnswerSubmit = async (data, selectedAnswerIndex) => {
    let endTime = new Date();
    setQuestionEndTime(endTime);
    setShowSubmit(false);
    data = convertArrayWithSeperator(data);
    let generatedChatId = generateNewChatId();
    setChatId(generatedChatId);
    setIsAnswerSubmitted(true);
    setUserQuery(data);
    let ans;
    if (!Array.isArray(selectedAnswer)) {
      ans = isNotEmptyOrNull(
        displayedQues?.[currentQuesIndex]?.answers_index_hashed_keys
      ) ?
      [selectedHashedIndexAnswer] :
      [selectedAnswer];
    }
    let time_diff = await getTimeDifference(questionStartTime, endTime);
    let response = matchFibAnswers(
      allAnswersData,
      ans,
      time_diff,
      isNotEmptyOrNull(displayedQues?.[currentQuesIndex]?.answers_key),
      displayedQues?.[currentQuesIndex]?.options_layout,
      isNotEmptyOrNull(
        displayedQues?.[currentQuesIndex]?.answers_index_hashed_keys
      )
    );
    let totalResultObj = {};
    if (taskType === taskTypes.assessment) {
      totalResultObj = { ...response };
    } else {
      totalResultObj = { ...response, chatId: generatedChatId };
    }

    let answerValue =
    displayedQues[0].question_type === questionTypes.nav ?
    totalResultObj?.overAllResult == true ?
    1 :
    2 :
    totalResultObj?.overAllResult == true ?
    1 :
    0;
    setOverAllQuestionResult(totalResultObj || false);
    setAnswerCount(answerValue);

    //calling update journey API
    if (
    (isEmptyOrNull(displayedQues[currentQuesIndex]?.factual) ||
    displayedQues[currentQuesIndex]?.factual !== true) &&
    !location?.pathname?.includes("practice-by-questionid"))
    {
      let { basketId, journey } = getUpdateJourneyDetails(
        learningStepData,
        journeyId
      );

      updateJourneyCall(
        journey,
        learningStepData?.questions?.[0]?.version_uuid,
        basketId,
        totalResultObj
      );
    }

    if (displayedQues[currentQuesIndex]?.factual === true) {
      if (isNotEmptyOrNull(totalResultObj)) {
        let endTime = new Date();
        setQuestionEndTime(endTime);
        const factualArray = {
          question: displayedQues[currentQuesIndex]?.version_uuid,
          user_answer: encodeURIComponent(JSON.stringify(totalResultObj)),
          result: totalResultObj?.overAllResult,
          time_taken: await getTimeDifference(questionStartTime, endTime)
        };

        setFactualAnswersList((prevList) => [...prevList, factualArray]);
      }
      setDisplayedQues((prevArray) => [
      ...prevArray.slice(0, -1), // Keep all items except the last one unchanged
      { ...prevArray[prevArray.length - 1], isSubmitted: true } // Modify the last item to set isSubmitted: true
      ]);
      buttons?.handleConclude();
    } else if (taskType === taskTypes.assessment) {
      handleButtonClick(totalResultObj, answerValue);
    } else {
      let query = isNotEmptyOrNull(data) ?
      data :
      `Option ${String.fromCharCode(65 + selectedAnswerIndex)}`;
      handlePracticeConv(
        query,
        false,
        false,
        totalResultObj?.answerResult?.[0]?.givenAnswer
      );
    }
  };

  const handleShowToast = (status, type) => {
    toast({
      title: type,
      position: "top",
      description: status,
      status: type,
      duration: 1500,
      isClosable: true
    });
  };

  const handleButtonClick = async (result, value) => {
    setIsNextQuestionLoading(true);
    setIsConvCompleted(false);

    if (
    learningStepData?.factual_rule_set?.[0]?.questions?.length > 0 &&
    factualIndexRef.current <
    learningStepData?.factual_rule_set?.[0]?.questions?.length &&
    !isLastQues)
    {
      setIsAnswerSubmitted(false);
      setDisplayQuestionsWithoutFactualVideo(false);
      setShowNextBtnForFactual(false);
      setIsFeedbackSubmitted(false);
      const updatedIndex = currentQuesIndex + 1;
      setCurrentQuestionIndex(updatedIndex);
      setQuestionStartTime(new Date());
      setDisplayedQues((prevArray) => [
      ...prevArray,
      {
        ...learningStepData?.factual_rule_set?.[0]?.questions[
        factualIndexRef.current],
        // Spread the existing object
        factual: true, // Add the new key-value pair
        showGreen: true,
        showRed: true
      }]
      );
      setFactualIndex(factualIndexRef.current + 1);
    } else if (
    isNotEmptyOrNull(learningStepData?.factual_rule_set?.[0]?.questions))
    {
      setIsAnswerSubmitted(false);
      let factData = {
        eval_state: "advanced",
        step_id: learningStepData?.step_id,
        question_asked_time: "",
        segment: 1,
        questions: factualAnswersListRef.current
        // has to construct answer array
      };
      const { success, data } = await postFactualProgress(
        factData,
        learningStepData?.lp_id,
        learningStepData?.basket,
        learningStepData?.journey_id
      );
      if (success) {
        setFactualAnswersList([]);
        setFactualIndex(0);
        handleNextQuestion(result, 1);
      } else {
        handleShowToast("Failed to post Factual questions", status.error);
      }
    } else {
      setFactualAnswersList([]);
      setFactualIndex(0);
      handleNextQuestion(result, value);
    }

    if (isLastQues) {
      setIsFetching(false);
    }
  };

  const editor = () => {
    return (
      <PlainInput
        isDisable={
        isNextQuestionLoading ?
        true :
        isDescSubmitted ?
        false :
        isLastQues ?
        true :
        (!isAnswerSubmitted || !isEmptyOrNull(selectedJourney)) &&
        !isDescAnsQues
        }
        buttons={buttons}
        displayedQues={displayedQues}
        onNewChapterClick={onNewChapterClick}
        handleNextQuestionClick={() => {
          handleButtonClick();
        }}
        handleFeedBackClick={() => setOpenFeedbackModal(true)}
        handleSubmitClick={() =>
        handleAnswerSubmit(selectedAnswer, selectedAnswerIndex)
        }
        displaySubmit={showSubmitRef.current}
        handleSubmit={(query, images) => {
          if (isDescAnsQues) {
            handleSubmitDescriptiveAnswer(query, images);
          } else {
            handlePracticeConv(query);
          }
        }}
        currentQues={displayedQues[currentQuesIndex]}
        resetPractice={() => {
          // window.location.reload();
          resetPractice();
        }} />);


  };
  const onNewChapterClick = () => {
    setIsAnswerSubmitted(false);
    resetPractice();
  };

  const handleShowMedia = (item) => {
    setSelectedMedia({
      ...item,
      media_type: item?.type,
      url: item?.content
    });
    setOpenMedia(true);
  };

  const displaySubmit = (answers, answer, hashedIndexAnswer, selectedIndex) => {
    setAllAnswersData(answers);
    setSelectedAnswer(answer);
    setSelectedHashedIndexAnswer(hashedIndexAnswer);
    setSelectedAnswerIndex(selectedIndex);
    setShowSubmit(true);
  };

  useEffect(() => {
    if (isPlayerOpen) {
      setSelectedMedia({
        video_url:
        displayedQues?.[selectedFactualIndex]?.contents?.[0]?.content_details?.
        content ||
        displayedQues?.[selectedFactualIndex]?.contents?.[0]?.content,
        media_type: "video",
        video_metadata: [
        displayedQues?.[selectedFactualIndex]?.factual_rule_set?.[0]?.
        start_time,
        displayedQues?.[selectedFactualIndex]?.factual_rule_set?.[0]?.
        end_time],


        video_id:
        displayedQues?.[selectedFactualIndex]?.contents?.[0]?._id ||
        displayedQues?.[selectedFactualIndex]?.contents?.[0]?.content_details?.
        _id
      });
      setOpenMedia(true);
    }
  }, [isPlayerOpen]);

  const handleSelectAction = (action, topicInfo, subTopicInfo) => {
    switch (action) {
      case taskTypes.guidedPractice:
        setSelectedIndex(3);
        setTaskCategory(1);
        break;
      case taskTypes.assessment:
        setSelectedIndex(5);
        setTaskCategory(2);
        break;
      case taskTypes.learnSubTopic:
        setSelectedIndex(4);
        setTaskCategory(4);
        break;
      case taskTypes.learnPrerequisite:
        setSelectedIndex(3);
        setTaskCategory(3);
        break;
      default:
        break;
    }
    //assigning topic and subtopic details
    setTopic(topicInfo?.label);
    setTopicMasterUuid(topicInfo?.value);
    setTopicName(topicInfo?.label);

    setSubTopic(subTopicInfo?.label);
    setSubTopicName(subTopicInfo?.label);
    setSubtopicId(subTopicInfo?.value);
    if (taskTypes.learnSubTopic === action) {
      setSubtopicMasterUuid(subTopicInfo?.uuid);
    } else {
      setSubtopicMasterUuid(subTopicInfo?.value);
    }
  };

  const PracticeParentStyles = `${isAnswerSubmitted ? styles["disabled"] : ""}`;

  const Classifier = () => {
    return (
      <React.Fragment>
        {currentQuesIndex == -1 && isEmptyOrNull(selectedSubTopic) ?
        <WelcomeClassifier
          unlockProps={props?.unlockProps}
          handleSelect={handleSelectAction} /> :


        <>
            {isStandalone &&
          <WelcomeClassifier
            unlockProps={props?.unlockProps}
            handleSelect={handleSelectAction} />

          }
            {!backUpObjectRef?.current?.successObject?.isTaskCompleted &&
          <div className={PracticeParentStyles}>
                <PracticeLayout
              saveEvent={handleVideoEventWithContext}
              displaySubmit={displaySubmit}
              isAnswerSubmitted={isAnswerSubmitted}
              handleDisplayQuestionsForFactual={() => handleButtonClick()}
              overAllQuestionResult={overAllQuestionResult}
              subjectMasterUuid={subjectMasterUuid}
              topicMasterUuid={topicMasterUuid}
              journeyId={journeyId}
              isDiscussFlow={isDiscussFlow}
              authToken={authToken} />

              </div>
          }
          </>
        }
      </React.Fragment>);

  };

  const drawerStyle = `${styles["drawer"]} ${
  openPracSideMenu ? styles["drawer-open"] : ""}`;

  const mediaMenuStyle = `${styles["media-menu"]} ${
  mediaDetails?.length > 0 ? styles["drawer-open"] : ""}`;


  let subjectMasterUuid =
  props?.selectedTopic?.subject?.subjectMasterUuid ||
  selectedTopic?.subject?.subjectMasterUuid ||
  props?.subjectMasterUuid ||
  "";
  let topicMasterUuid =
  props?.selectedTopic?.topic?.topicMasterUuid ||
  selectedTopic?.topic?.topicMasterUuid ||
  props?.topicMasterUuid ||
  "";

  // useEffect(() => {
  //   if (isNotEmptyOrNull(selectedTopic)) {
  //     setPracticeSubjectMasterUuid(subjectMasterUuid);
  //     setPracticeTopicMasterUuid(topicMasterUuid);
  //     StorageService.setItem("subjectMasterUUid", subjectMasterUuid);
  //     StorageService.setItem("topicMasterUUid", topicMasterUuid);
  //   }
  // }, [selectedTopic]);

  return (
    <div className={styles["practice"]}>
      <div className={styles["content-container"]} ref={divRef}>
        <div className={styles["content"]} style={{ flex: 1 }}>
          {isEmptyOrNull(selectedJourney) &&
          !props?.passByQuestion &&
          Classifier()}
          {props?.passByQuestion &&
          <React.Fragment>
              <PracticeByQuestion
              chatId={chatId}
              isPlayground={isPlayground || isDescAnsQues} />

              <div style={isAnswerSubmitted ? { pointerEvents: "none" } : {}}>
                {isDescAnsQues ?
              <DescriptiveAnswer /> :

              <PracticeLayout
                displaySubmit={displaySubmit}
                isAnswerSubmitted={isAnswerSubmitted}
                isDiscussFlow={isDiscussFlow} />

              }
              </div>
            </React.Fragment>
          }
          {!isEmptyOrNull(selectedJourney) &&
          <TutorReviewMode journeyId={selectedJourney} />
          }
          {(isNotEmptyOrNull(selectedTopic) &&
          isNotEmptyOrNull(subjectMasterUuid) &&
          isNotEmptyOrNull(topicMasterUuid) &&
          isEmptyOrNull(selectedJourney) ||
          isDiscussFlow ||
          isNotEmptyOrNull(backUpObjectRef?.current)) &&
          <LearnSideNav
            isOpen={openLearnSideMenu}
            onSubtopicClick={handleNavItemCLick}
            onClose={closeLearnSideNav}
            subjectMasterUuid={
            subjectMasterUuid || backUpObjectRef?.current?.subjectMasterUuid
            }
            topicMasterUuid={
            topicMasterUuid || backUpObjectRef?.current?.topicMasterUuid
            } />

          }
        </div>

        {!openProfileMenu &&
        !openLearnSideMenu &&
        mediaDetails?.length > 0 &&
        window?.ENV?.ENABLE_GP_MEDIA == "true" &&
        <PracticeMedia
          mediaDetails={mediaDetails}
          handleShowMedia={handleShowMedia}
          openRelatedContent={openRelatedContent}
          toggleRelatedContent={toggleRelatedContent}
          isMobile={isMobile} />

        }

        {openPracSideMenu && !isMobile &&
        <div className={drawerStyle}>
            <Image
            cursor={"pointer"}
            onClick={togglePracDrawer}
            src={RightArrowicon} />

            <PracticeHistoryList />
          </div>
        }
      </div>
      <div style={{ width: "100%" }}>
        <div className={styles.bottom}>{editor()}</div>
        <Box height={"28px"} bgColor={"#F5F4FA"}></Box>
      </div>
      {openFeedbackModal &&
      <FeedbackModal
        chatId={chatId}
        mode={"Practice"}
        setIsFeedbackSubmitted={setIsFeedbackSubmitted}
        curriculumObj={curriculumObj} />

      }
      {(isTaskCompleted ||
      backUpObjectRef?.current?.successObject?.isTaskCompleted) &&
      <Modal
        size={"full"}
        onClose={() => {
          setCurrentQuestionIndex(-1);
          setIsTaskCompleted(false);
        }}
        taskType={taskType || backUpObjectRef?.current?.taskType} />

      }
      {openPracSideMenu && isMobile && <PracticeHistoryBottomSheet />}
      {openMedia &&
      <MediaModal
      // Required props
      authToken={authToken}
      selectedMedia={selectedMedia}
      openMedia={openMedia}
      handleClose={() => {
        setOpenMedia(false);
        setIsPlayerOpen(false);
      }}
      // Optional props for customization
      updateVideoEvents={handleVideoEventWithContext}
      styles={styles}
      modalSize="3xl"
      modalZIndex={3500}
      videoAspectRatio={16 / 9}
      imageMaxHeight="360px"
      maxModalHeight="70vh"
      // iOS optimizations
      enableIOSOptimizations={true}
      iosCloseDelay={300} />

      }
    </div>);

};

export default Practice;